export enum FILESCACHE_KEYS {
  STORE_NAME = 'eduac-store',
  STORE_VAL = 'eduacval',
  STORE_EXP = 'eduacexp',
  BUILDER_TEMPLATES = 'builder_templates',
  BUILDER_DATA = 'builder_data',
  BUILDER_QUEUE = 'builder_queue',
  MASTER_DATA = 'master_data',
  STORE_EXP_TIME = 28
}

export const CACHE_STORE_KEYS : string[] = [
  FILESCACHE_KEYS.STORE_EXP as string,
  FILESCACHE_KEYS.STORE_VAL as string,
  FILESCACHE_KEYS.BUILDER_DATA as string,
  FILESCACHE_KEYS.BUILDER_TEMPLATES as string,
  FILESCACHE_KEYS.BUILDER_QUEUE as string,
  FILESCACHE_KEYS.MASTER_DATA as string
];